<template>
    <div class="tortchart">
        <div :style="{height:'357px',paddingTop:'10px',width:'100%'}" :id="id"></div>
    </div>
</template>
<script>
    import echarts from 'echarts/lib/echarts';
    // 引入柱状图和饼状图
    import  'echarts/lib/chart/bar';
    import  'echarts/lib/chart/pie';
    // 引入提示框和标题组件
    import 'echarts/lib/component/tooltip';
    import 'echarts/lib/component/title';
    import 'echarts/lib/component/legend';
    // import 'echarts/lib/component/toolbox';
    import 'echarts/lib/component/axis';
    import 'echarts/lib/component/axisPointer';
    import $ from 'jquery';
    export default {
        name:'tortChart',
        props:{
            id:Number,
            type:String,
            numberD:String,
            title:String,
            bz:String,
            copyrightNameD:String,
            copyrightVendorNameD:String,
            legend:{
                type:Array,
                default:()=>[]
            },
            series:{
                type:Array,
                default:()=>[]
            },
        },
        data(){
            return {
                dataList:[],
                myHeight:'357px'
            }
        },
        mounted(){
            this.$nextTick(() => {
                this.init();
            })
        },
        methods:{
            init(){
                let legend = this.legend;
                let data = this.series
                this.tortChart(legend,data)
            },
            getBzChartList(){
                let _this = this;
                _this.myHeight = '357px';
                this.$nextTick(() => {
                    let params = {
                        copyrightName:this.copyrightNameD,
                        copyrightVendorName:this.copyrightVendorNameD,
                    }
                    if(!this.copyrightVendorNameD){
                            delete params.copyrightVendorName
                        }
                        if(!this.copyrightNameD){
                            delete params.copyrightName
                        }
                    _this.getRequest("/copyrightTotal/getCopyrightIncomePie",params).then(res => {
                        console.log(res)
                        console.log('?????????????????????????我是神2',Object.keys(res).length)
                        if(Object.keys(res).length>0){
                            _this.tortChart(res.legend,res.series)
                        }else{
                            _this.myHeight = 0;
                        }
                    });
                })
            },
            // 圆柱图
            tortChart(legend,data){
                legend = this.legend;
                data = this.series
                var optionTort = {
                    title:{
                        text: this.title,
                        subtext: '',
                        left: 'left'
                    },
                    tooltip: {
                        trigger: 'item',
                        formatter: "{a} <br/>{b}: {c} ({d}%)",
                        show: false,
                    },
                    legend: {
                        icon:'circle',
                        itemWidth:10,
                        itemHeight:10,
                        left:'center',
                        bottom:0,
                        data:legend,
                        formatter:  function(name){
                            return name
                        }
                    },
                    series: [
                        {
                            name:'访问来源',
                            type:'pie',
                            center: ['50%', '50%'],
                            selectedMode: 'single',
                            data:data,
                            avoidLabelOverlap: false,
                            label: {
                                normal: {
                                    show: true,
                                    position: 'outside',
                                    formatter: '{b}\r\n\r\n{c} ({d}%)',
                                    textStyle: {
                                        fontSize: '14',
                                        fontWeight: '400'
                                    }
                                },
                            },
                            labelLine: {
                                normal: {
                                    show: true
                                }
                            },
                            itemStyle:{
                                normal:{
                                    color:function(params){
                                        var colorList = [
                                            '#FFD800','#9BD87C','#E19CFF','#9C99FF','#FF7575','#800000','#800080','#808000','#7FFF00','#778899','#FFD800','#9BD87C','#E19CFF','#9C99FF','#FF7575'
                                        ]
                                        return colorList[params.dataIndex]
                                    }
                                }
                            }
                        }
                    ]
                }
                if(this.type=='yuans1' || this.type=='yuans2'){
                    optionTort.series[0].radius=['55%', '70%']
                }
                var tortChart = echarts.init(document.getElementById(this.id))
                tortChart.on('legendselectchanged', ({ selected, name }) => {
                    selected[name] = true
                    tortChart.setOption({ legend: { selected } })
                })
                // 使用刚指定的配置项和数据显示图表。
                
                // window.onresize = function () {
                //     myLeftChart.resize();
                // }
                // 使用刚指定的配置项和数据显示图表。
                setTimeout(function(){
                    tortChart.setOption(optionTort,true)
                    tortChart.resize();
                },1500)
                // window.onresize = function () {
                //     myBottomChart.resize();
                // }
                $(window).resize(function(){
                    tortChart.resize();
                });

            }
        }
    }

</script>